import { useDispatch } from "react-redux";
import { Trash2 } from "lucide-react";
import { updateQty } from "../modules/cart/actions";
import {
  ProductAction,
  ProductQuantityControls as Controls,
} from "./styles";

function ProductQuantityControls({ productId, productName, quantity }) {
  const dispatch = useDispatch();

  const updateQuantity = (val) => {
    dispatch(updateQty({ id: productId, val }));
  };

  return (
    <Controls>
      <ProductAction
        type="button"
        aria-label={
          quantity === 1
            ? `Usuń z koszyka: ${productName}`
            : `Zmniejsz liczbę: ${productName}`
        }
        onClick={() => updateQuantity(-1)}
      >
        {quantity === 1 ? <Trash2 aria-hidden="true" /> : "-"}
      </ProductAction>
      <span aria-label={`Liczba sztuk: ${quantity}`}>{quantity}</span>
      <ProductAction
        type="button"
        aria-label={`Zwiększ liczbę: ${productName}`}
        onClick={() => updateQuantity(1)}
      >
        +
      </ProductAction>
    </Controls>
  );
}

export default ProductQuantityControls;
